import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'

const CertiManage = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<div style={{ fontSize: "2rem", fontWeight: 500 }}>인증서 관리</div>
				<ul className="document-select mt_40">
					<li>
						<i className="icon icon_document" />
						<div className="ml_20">
							<p>김모니</p>
							<ul className="mt_10">
								<li>
									<span>발급자</span>
									<span>금융결제원</span>
								</li>
								<li>
									<span>용도</span>
									<span>은행/보험용</span>
								</li>
								<li>
									<span>만료일</span>
									<span>2022년 4월 7일<i className="tag tag-round tag-red ml_5">D-46</i></span>
								</li>
							</ul>
						</div>
					</li>
					<li>
						<i className="icon icon_document warn" />
						<div className="ml_20">
							<p>김모니</p>
							<ul className="mt_10">
								<li>
									<span>발급자</span>
									<span>코스콤</span>
								</li>
								<li>
									<span>용도</span>
									<span>증권용</span>
								</li>
								<li>
									<span>만료일</span>
									<span>2022년 9월 7일<i className="tag tag-round tag-red ml_5">D-6</i></span>
								</li>
							</ul>
						</div>
					</li>
					<li className="over">
						<i className="icon icon_document over" />
						<div className="ml_20">
							<p>김모니</p>
							<ul className="mt_10">
								<li>
									<span>발급자</span>
									<span>코스콤</span>
								</li>
								<li>
									<span>용도</span>
									<span>증권용</span>
								</li>
								<li>
									<span>만료일</span>
									<span>2021년 4월 7일</span>
								</li>
							</ul>
						</div>
					</li>
				</ul>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">인증서 가져오기</Button>
			</div>
		</div>
	)
}

export default CertiManage
